import React from "react";
import GalleryCTR from "../containers/gallery/GalleryCTR"; 

function Gallery() {
  return (
    <>
      <GalleryCTR />
    </>
  );
}

export default Gallery;
